import { Component, Input, OnInit } from "@angular/core";
import { Practitioner } from "src/app/core/model/v2/practitioner/practitioner";

@Component({
  selector: "app-hospital-card-dialog",
  templateUrl: "./hospital-card-dialog.component.html",
  styleUrls: ["./hospital-card-dialog.component.scss"],
})
export class HospitalCardDialogComponent implements OnInit {
  @Input() practitionerData: Practitioner = new Practitioner(); //@Input()

  constructor() {}

  ngOnInit() {}
}
